import { render, staticRenderFns } from "./ocr.vue?vue&type=template&id=2b3969a4&scoped=true&"
import script from "./ocr.vue?vue&type=script&lang=js&"
export * from "./ocr.vue?vue&type=script&lang=js&"
import style0 from "./ocr.vue?vue&type=style&index=0&id=2b3969a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3969a4",
  null
  
)

export default component.exports